<template>
  <div class="navbar">
    <div class="navbar-inner w-100">
      <div class="sidebar-pusher">
        <a
          href="javascript:void(0);"
          class="waves-effect waves-button waves-classic push-sidebar"
        >
          <i class="fa fa-bars"></i>
        </a>
      </div>
      <div class="logo-box">
        <span class="helper"></span>
        <img src="/static/medialab.png" />
      </div>
      <div class="search-button">
        <a
          href="javascript:void(0);"
          class="waves-effect waves-button waves-classic show-search"
        >
          <i class="fa fa-search"></i>
        </a>
      </div>
      <div class="topmenu-outer">
        <div class="top-menu">
          <ul
            class="nav navbar-nav navbar-right d-flex flex-row justify-content-end"
            id="top-list"
          >
            <li class="language-select">
              <component is="LanguageSwitcher"></component>
            </li>
            <li>
              <span class="username">
                <button
                  class="top-avatar waves-effect waves-button waves-classic"
                >
                  <span> {{ userName }} </span>
                </button>
              </span>
            </li>
            <li>
              <router-link
                :to="'/logout'"
                class="log-out btn-logout waves-effect waves-button waves-classic"
                ><i class="fa fa-share" aria-hidden="true"></i>
                {{ $t("message.Выход") }}
              </router-link>
            </li>
          </ul>
        </div>
        <!-- Top Menu -->
      </div>
    </div>
  </div>
  <!-- Navbar -->
</template>

<script>
import LanguageSwitcher from "../Nav/LanguageSwitcher";
export default {
  name: "NavBar",
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      userName: "asd"
    };
  },
  created() {
    let userInfo = this.$noname.get("me");

    return userInfo
      .then(data => {
        this.userName = data.data.username;
        this.$storage.set("current_user", data.data);
        return data;
      })
      .catch(this.$noname.HandleError);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Nav/NavBar.vue